import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import styles from './Variant.module.css';

import type { VariantData } from '@Pages/PageQuizMattrasses/typings';
import type { FC, HTMLAttributes, MouseEvent } from 'react';

export interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'onSelect'> {
  className?: string;
  variant: VariantData;
  onSelect?: (e: MouseEvent, variant: VariantData) => void;
}

const Variant: FC<Props> = (props) => {
  const { className, variant, onSelect, ...restProps } = props;

  const handleSelect = useCallback(
    (e: MouseEvent) => {
      if (variant.disabled) return;
      if (onSelect) onSelect(e, variant);
    },
    [onSelect, variant],
  );

  return (
    <div
      {...restProps}
      className={cn(
        styles.wrapper,
        { [styles.selected]: variant.selected, [styles.disabled]: variant.disabled },
        className,
      )}
      onClick={handleSelect}
    >
      <div className={styles.wrapperIcon}>
        <div className={styles.iconCheck} />
        <img className={styles.icon} src={variant.icon} alt='' />
      </div>

      {variant.title && <div className={styles.title}>{variant.title}</div>}
    </div>
  );
};

export default memo(Variant);
